
import { Options, Vue } from "vue-class-component";
import Turret from "@/entities/Turret";
import Card from "@/components/common/Card.vue";
import Field, { RuleTypes } from "@/entities/Contracts/Field";
import AppInput from "@/components/common/form/AppInput.vue";
import AppButton from "@/components/common/AppButton.vue";
import TurretFieldsTable from "@/components/turret/contracts/TurretFieldsTable.vue";

@Options({
  components: { TurretFieldsTable, AppButton, AppInput, Card },
  emits: ["fieldsUpdated"],
  props: {
    turret: {
      type: Turret,
    },
  },
})
export default class TurretForm extends Vue {
  private fields: Field[] = [];
  private editableField: Field = Field.createNull();
  private rules = RuleTypes;
  private editing = false;

  saveField(): void {
    const { name, type, description, rule } = this.editableField;
    const currentField = this.fields.find((f) => f === this.editableField);
    if (currentField) {
      currentField.name = name;
      currentField.type = type;
      currentField.description = description;
      currentField.rule = rule;
    } else {
      this.fields = [...this.fields, new Field(name, type, description, rule)];
    }

    this.editableField = Field.createNull();
    this.editing = false;
    this.$emit("fieldsUpdated", this.fields);
  }

  editField(field: Field): void {
    this.editableField = field;
    this.editing = true;
  }

  deleteField(field: Field): void {
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i] === field) {
        this.fields.splice(i, 1);
      }
    }
  }
}
